






















import ApiSearch from "@/components/apiSearch/components/ApiSearch.vue";
import StatusChip from "@/components/StatusChip.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import StatusColorMap from "@/models/StatusColorMap";
import FixAssetApiSearchDTO from "../../models/FixAssetApiSearchDTO";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  components: { ApiSearch, StatusChip },

  data: () => ({
    statusColoring: new StatusColorMap({
      default: "grey",
      3: "teal",
      4: "green",
    }),
  }),

  methods: {
    itemSelected(fixAsset: FixAssetApiSearchDTO) {
      this.$emit("itemSelected", fixAsset);
    },
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      { field: "id", title: t("Azonosito") },
      { field: "name", title: t("Megnevezes") },
      { field: "supplier", title: t("Szallito") },
      {
        field: "netto",
        title: t("InvoiceItems_BeszerzesiNettoErtek"),
        type: ColumnType.Money,
      },
      { field: "currency", title: t("Penznem") },
      { field: "description", title: t("Leiras") },
      { field: "type", title: t("Tipus") },
      { field: "inventoryId", title: t("InvoiceItems_LeltariSzam") },
      { field: "factNumber", title: t("InvoiceItems_Keszletazonosito") },
      {
        field: "status",
        title: t("Statusz"),
        type: ColumnType.Center,
        cell: "status",
        multiselectField: "selectedStatuses",
        multiselectOptions: [
          { value: 2, text: t("FeldolgozasAlatt") },
          // { value: 3, text: "Beruházva" },
          { value: 4, text: t("InvoiceItems_Aktivalva") },
        ],
        multiselect: true,
      },
    ],
  },
});
